import axios from 'axios';

// 后续配置跳转链接地址
// 生产:https://huajiantong.com/
// 测试: http://10.96.133.254:8081
const service = axios.create({
    timeout: 40000,
    baseURL: 'https://api-pc.pomoho.com' //生产地址
    // baseURL: 'https://dev.pomoho.com' //测试地址
})

// 请求拦截
service.interceptors.request.use(config => {
    // 处理参数
    return config;
},err => {
    console.log("请求拦截报错内容："+err)
})

// 响应拦截
service.interceptors.response.use(response => {
    // 处理参数
    return response;
},err => {
    console.log("响应拦截报错内容："+err)
})


// 导出请求函数
export function get(url, params){
    return service.get(url, {params})
}

export function post(url, data){
    return service.post(url, data)
}

export function setBaseURLGet(baseURL,url, data){
    service.defaults.baseURL = baseURL;
    return service.get(url)
}
export function setBaseURLPost(baseURL,url, data){
    service.defaults.baseURL = baseURL;
    return service.post(url,data)
}

export function ifProduction(){
    // console.log(service.defaults.baseURL)
    if(service.defaults.baseURL.indexOf("api-pc.pomoho.com")>=0){
        return true
    }else{
        return false
    }
}